import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Box from '@mui/joy/Box';
import { saveLanguagePreference } from '../../services/settingsService';

interface LanguageSwitcherProps {
  compact?: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ compact = false }) => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = async (_event: any, value: string | null) => {
    if (value) {
      i18n.changeLanguage(value);
      localStorage.setItem('i18nextLng', value);
      await saveLanguagePreference(value);
      // Force page reload to ensure all components update
      window.location.reload();
    }
  };

  // Normalize language code to match our available languages
  const currentLang = i18n.language?.split('-')[0] || 'en';
  const displayLang = ['en', 'hi'].includes(currentLang) ? currentLang : 'en';

  return (
    <Box sx={{ minWidth: compact ? 'auto' : 150 }}>
      <Select
        value={displayLang}
        onChange={handleLanguageChange}
        sx={{
          width: '100%',
          minWidth: compact ? '80px' : '150px',
          fontSize: compact ? '0.875rem' : 'inherit',
        }}
        slotProps={{
          button: {
            sx: (theme) => ({
              padding: compact ? '0.5rem' : 'inherit',
              backgroundColor: theme.palette.mode === 'dark' ? 'background.surface' : 'background.level1',
              borderColor: theme.palette.mode === 'dark' ? 'divider' : 'neutral.outlinedBorder',
              color: theme.palette.mode === 'dark' ? 'text.primary' : 'inherit',
              '&:hover': {
                backgroundColor: theme.palette.mode === 'dark' ? 'background.level1' : 'background.level2',
              },
            }),
          },
          listbox: {
            sx: (theme) => ({
              backgroundColor: theme.palette.mode === 'dark' ? 'background.body' : 'background.surface',
              borderColor: theme.palette.mode === 'dark' ? 'divider' : 'neutral.outlinedBorder',
            }),
          },
        }}
      >
        <Option value="en">
          {t('common.english')}
        </Option>
        <Option value="hi">
          {t('common.hindi')}
        </Option>
      </Select>
    </Box>
  );
};

export default LanguageSwitcher;
